/**
 * Best Sellers Badge for Third-party Plugin Container
 * Adds badge to pwzrswiper-container-wrapper based on product metafields
 */

class BestSellersBadge {
  constructor() {
    console.log('🏷️ Best Sellers Badge: 初始化开始');
    this.containerSelector = '#pwzrswiper-container-wrapper';
    this.badgeClass = 'best-sellers-badge';
    console.log('🏷️ Best Sellers Badge: 目标容器选择器:', this.containerSelector);
    this.init();
  }

  init() {
    console.log('🏷️ Best Sellers Badge: 检查DOM状态:', document.readyState);
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      console.log('🏷️ Best Sellers Badge: DOM正在加载，等待DOMContentLoaded事件');
      document.addEventListener('DOMContentLoaded', () => this.setupBadge());
    } else {
      console.log('🏷️ Best Sellers Badge: DOM已就绪，立即设置角标');
      this.setupBadge();
    }
  }

  setupBadge() {
    console.log('🏷️ Best Sellers Badge: 开始设置角标');
    // Try to find the container, with retry mechanism for dynamic content
    this.findContainerAndAddBadge();
    
    // Also set up observer for dynamic content changes
    console.log('🏷️ Best Sellers Badge: 设置DOM变化监听器');
    this.observeForContainer();
  }

  findContainerAndAddBadge() {
    console.log('🏷️ Best Sellers Badge: 查找目标容器:', this.containerSelector);
    const container = document.querySelector(this.containerSelector);
    
    if (container) {
      console.log('🏷️ Best Sellers Badge: ✅ 找到目标容器:', container);
      console.log('🏷️ Best Sellers Badge: 检查角标显示条件...');
      this.checkAndAddBadge(container);
    } else {
      console.log('🏷️ Best Sellers Badge: ❌ 未找到目标容器');
    }
  }

  observeForContainer() {
    console.log('🏷️ Best Sellers Badge: 创建MutationObserver监听DOM变化');
    // Create observer to watch for the container being added dynamically
    const observer = new MutationObserver((mutations) => {
      console.log('🏷️ Best Sellers Badge: 检测到DOM变化，重新查找容器');
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is our target container
            if (node.id === 'pwzrswiper-container-wrapper' || 
                (node.querySelector && node.querySelector(this.containerSelector))) {
              console.log('Detected pwzrswiper-container-wrapper added to DOM');
              setTimeout(() => this.findContainerAndAddBadge(), 100);
            }
          }
        });
      });
    });

    console.log('🏷️ Best Sellers Badge: 开始监听body元素的子树变化');
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  checkAndAddBadge(container) {
    console.log('🏷️ Best Sellers Badge: 开始检查角标显示条件');
    
    // 检查容器是否有效
    if (!container || !container.style) {
      console.log('🏷️ Best Sellers Badge: ❌ 容器无效或不存在');
      return;
    }
    
    // Get product data
    console.log('🏷️ Best Sellers Badge: 获取产品数据...');
    const productData = this.getProductData();
    if (!productData) {
      console.log('🏷️ Best Sellers Badge: ❌ 无法获取产品数据');
      return;
    }
    console.log('🏷️ Best Sellers Badge: ✅ 获取到产品数据:', productData);

    // Get best sellers metafield
    console.log('🏷️ Best Sellers Badge: 获取best_sellers元字段...');
    const bestSellersData = this.getBestSellersMetafield(productData);
    if (!bestSellersData) {
      console.log('🏷️ Best Sellers Badge: ❌ 未找到best_sellers元字段');
      // 如果没有best_sellers数据，移除现有角标
      this.removeBadgeFromContainer(container);
      return;
    }
    console.log('🏷️ Best Sellers Badge: ✅ 获取到best_sellers数据:', bestSellersData);

    // Get current product color
    console.log('🏷️ Best Sellers Badge: 获取当前产品颜色...');
    const currentColor = this.getCurrentProductColor(productData);
    if (!currentColor) {
      console.log('🏷️ Best Sellers Badge: ❌ 无法获取当前产品颜色');
      // 如果没有颜色信息，移除现有角标
      this.removeBadgeFromContainer(container);
      return;
    }
    console.log('🏷️ Best Sellers Badge: ✅ 当前产品颜色:', currentColor);

    // Parse and check best sellers data
    console.log('🏷️ Best Sellers Badge: 解析best_sellers数据并检查颜色匹配...');
    const shouldShowBadge = this.checkColorMatch(bestSellersData, currentColor);
    
    if (shouldShowBadge) {
      console.log('🏷️ Best Sellers Badge: ✅ 满足显示条件，创建角标');
      this.addBadgeToContainer(container);
    } else {
      console.log('🏷️ Best Sellers Badge: ❌ 不满足显示条件，移除角标');
      this.removeBadgeFromContainer(container);
    }
  }

  getProductData() {
    console.log('🏷️ Best Sellers Badge: 尝试从多个数据源获取产品数据');
    
    // Method 1: From window.productData (passed from Liquid template)
    if (window.productData) {
      console.log('🏷️ Best Sellers Badge: ✅ 从window.productData获取数据');
      return window.productData;
    }
    console.log('🏷️ Best Sellers Badge: ❌ window.productData不存在');

    // Method 2: From window.meta.product
    if (window.meta && window.meta.product) {
      console.log('🏷️ Best Sellers Badge: ✅ 从window.meta.product获取数据');
      return window.meta.product;
    }
    console.log('🏷️ Best Sellers Badge: ❌ window.meta.product不存在');

    // Method 3: From window.product
    if (window.product) {
      console.log('🏷️ Best Sellers Badge: ✅ 从window.product获取数据');
      return window.product;
    }
    console.log('🏷️ Best Sellers Badge: ❌ window.product不存在');

    // Method 4: From meta tags
    console.log('🏷️ Best Sellers Badge: 尝试从meta标签获取数据');
    const productIdMeta = document.querySelector('meta[name="product-id"]');
    const productHandleMeta = document.querySelector('meta[name="product-handle"]');
    
    if (productIdMeta || productHandleMeta) {
      console.log('🏷️ Best Sellers Badge: ✅ 从meta标签获取产品数据');
      return {
        id: productIdMeta ? productIdMeta.content : null,
        handle: productHandleMeta ? productHandleMeta.content : null
      };
    }
    console.log('🏷️ Best Sellers Badge: ❌ meta标签中未找到产品数据');

    // Method 5: From JSON-LD script
    console.log('🏷️ Best Sellers Badge: 尝试从JSON-LD脚本获取数据');
    const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of jsonLdScripts) {
      try {
        const data = JSON.parse(script.textContent);
        if (data['@type'] === 'Product') {
          console.log('🏷️ Best Sellers Badge: ✅ 从JSON-LD获取产品数据');
          return {
            id: data.productID,
            title: data.name,
            variants: data.offers ? (Array.isArray(data.offers) ? data.offers : [data.offers]) : []
          };
        }
      } catch (e) {
        console.log('🏷️ Best Sellers Badge: ❌ JSON-LD解析失败:', e);
      }
    }

    console.log('🏷️ Best Sellers Badge: ❌ 所有数据源都无法获取产品数据');
    return null;
  }

  shouldShowBadge(productData) {
    // Get best sellers metafield data
    const bestSellersData = this.getBestSellersMetafield();
    
    if (!bestSellersData) {
      console.log('No best_sellers metafield found');
      return false;
    }

    console.log('Best sellers metafield:', bestSellersData);

    // Get current product color
    const currentColor = this.getCurrentProductColor(productData);
    
    if (!currentColor) {
      console.log('No current color found');
      return false;
    }

    console.log('Current product color:', currentColor);

    // Parse and check color matching
    return this.checkColorMatch(bestSellersData, currentColor);
  }

  getBestSellersMetafield(productData) {
    console.log('🏷️ Best Sellers Badge: 尝试从多个来源获取best_sellers元字段');
    
    // Try to get from product data first
    if (productData && productData.metafields && productData.metafields.custom && productData.metafields.custom.best_sellers) {
      console.log('🏷️ Best Sellers Badge: ✅ 从productData.metafields.custom.best_sellers获取');
      return productData.metafields.custom.best_sellers;
    }
    console.log('🏷️ Best Sellers Badge: ❌ productData.metafields.custom.best_sellers不存在');

    // Try to get from meta tag
    const metaTag = document.querySelector('meta[name="product-metafield-best-sellers"]');
    if (metaTag) {
      console.log('🏷️ Best Sellers Badge: ✅ 从meta标签获取best_sellers');
      return metaTag.content;
    }
    console.log('🏷️ Best Sellers Badge: ❌ meta标签中未找到best_sellers');

    // Try to get from data attribute on body or product container
    const bodyData = document.body.dataset.bestSellers;
    if (bodyData) {
      console.log('🏷️ Best Sellers Badge: ✅ 从body数据属性获取best_sellers');
      return bodyData;
    }
    console.log('🏷️ Best Sellers Badge: ❌ body数据属性中未找到best_sellers');

    console.log('🏷️ Best Sellers Badge: ❌ 所有来源都无法获取best_sellers元字段');
    return null;
  }

  getCurrentProductColor(productData) {
    console.log('🏷️ Best Sellers Badge: 尝试获取当前产品颜色');
    
    // Try to get selected variant color
    let currentColor = null;

    // Method 1: From checked radio input in variant-input-wrapper (实时获取)
    const variantInputWrappers = document.querySelectorAll('.variant-input-wrapper');
    for (const wrapper of variantInputWrappers) {
      const checkedInput = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        // 检查是否是颜色选项（通过data-option-slug或fieldset的data属性）
        const optionSlug = wrapper.dataset.optionSlug;
        if (optionSlug && (optionSlug.includes('color') || optionSlug.includes('colour') || optionSlug.includes('颜色'))) {
          currentColor = checkedInput.value;
          console.log('🏷️ Best Sellers Badge: ✅ 从variant-input-wrapper获取颜色:', currentColor, '(option:', optionSlug, ')');
          return currentColor;
        }
      }
    }

    // Method 2: From color swatch (实时获取)
    const colorSwatch = document.querySelector('.color__swatch input[type="radio"]:checked');
    if (colorSwatch) {
      currentColor = colorSwatch.value;
      console.log('🏷️ Best Sellers Badge: ✅ 从color swatch获取颜色:', currentColor);
      return currentColor;
    }

    // Method 3: From URL parameters (实时获取)
    const urlParams = new URLSearchParams(window.location.search);
    // 尝试多种可能的参数名
    currentColor = urlParams.get('Color') || urlParams.get('color') || urlParams.get('颜色');
    if (currentColor) {
      console.log('🏷️ Best Sellers Badge: ✅ 从URL参数获取颜色:', currentColor);
      return currentColor;
    }
    
    // Method 4: From selected variant (fallback)
    if (productData.selected_or_first_available_variant && productData.selected_or_first_available_variant.option1) {
      currentColor = productData.selected_or_first_available_variant.option1;
      console.log('🏷️ Best Sellers Badge: ✅ 从selected_or_first_available_variant获取颜色:', currentColor);
      return currentColor;
    }
    
    // Method 5: From first variant (fallback)
    if (productData.variants && productData.variants.length > 0 && productData.variants[0].option1) {
      currentColor = productData.variants[0].option1;
      console.log('🏷️ Best Sellers Badge: ✅ 从第一个variant获取颜色:', currentColor);
      return currentColor;
    }

    console.log('🏷️ Best Sellers Badge: ❌ 无法获取当前产品颜色');
    return currentColor;
  }

  checkColorMatch(bestSellersData, currentColor) {
    console.log('🏷️ Best Sellers Badge: 开始检查颜色匹配');
    console.log('🏷️ Best Sellers Badge: best_sellers数据:', bestSellersData);
    console.log('🏷️ Best Sellers Badge: 当前颜色:', currentColor);
    
    // Check if bestSellersData is valid
    if (!bestSellersData || typeof bestSellersData !== 'string') {
      console.log('🏷️ Best Sellers Badge: ❌ best_sellers数据无效或不是字符串');
      return false;
    }
    
    // Split by comma and process each entry
    const entries = bestSellersData.split(',');
    
    console.log('🏷️ Best Sellers Badge: 处理条目:', entries);
    
    for (const entry of entries) {
      const trimmedEntry = entry.trim();
      const parts = trimmedEntry.split(':');
      
      console.log('🏷️ Best Sellers Badge: 处理条目:', trimmedEntry, '分割结果:', parts);
      
        if (parts.length === 2) {
          const attributeName = parts[0].trim().toUpperCase();
          const attributeValue = parts[1].trim().toUpperCase();
          
          console.log('🏷️ Best Sellers Badge: 属性名:', attributeName, '属性值:', attributeValue);
          
          if (attributeName === 'COLOR') {
            const currentColorUpper = currentColor.toUpperCase();
            console.log('🏷️ Best Sellers Badge: 比较颜色:', currentColorUpper, 'vs', attributeValue);
            
            if (currentColorUpper === attributeValue) {
              console.log('🏷️ Best Sellers Badge: ✅ 找到颜色匹配!');
              return true;
            }
          }
        }
    }
    
    console.log('🏷️ Best Sellers Badge: ❌ 未找到颜色匹配');
    return false;
  }

  addBadgeToContainer(container) {
    console.log('🏷️ Best Sellers Badge: 开始添加角标到容器');
    
    // 检查容器是否有效
    if (!container || !container.style) {
      console.log('🏷️ Best Sellers Badge: ❌ 容器无效或不存在，无法添加角标');
      return;
    }
    
    // Check if badge already exists
    const existingBadge = container.querySelector(`.${this.badgeClass}`);
    if (existingBadge) {
      console.log('🏷️ Best Sellers Badge: ⚠️ 角标已存在，跳过创建');
      return;
    }
    
    // Create badge element
    const badge = document.createElement('div');
    badge.className = this.badgeClass;
    badge.innerHTML = `
      <div class="best-sellers-badge-bg">
        <span>Best Sellers</span>
      </div>
    `;

    // Add styles
    badge.style.cssText = `
      position: absolute;
      top: 0.8rem;
      left: 0.8rem;
      z-index: 2;
      background: #CAFED8;
      color: #34BFAC;
      padding: 0.4rem 0.8rem;
      border-radius: 0.4rem;
      font-size: 1.2rem;
      font-weight: 700;
      font-family: Montserrat-bold;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      font-family: inherit;
    `;

    // Ensure container has relative positioning
    const containerStyle = window.getComputedStyle(container);
    if (containerStyle.position === 'static') {
      console.log('🏷️ Best Sellers Badge: 设置容器为relative定位');
      container.style.position = 'relative';
    }

    // Add badge to container
    container.appendChild(badge);
    
    console.log('🏷️ Best Sellers Badge: ✅ 角标添加成功');
  }

  removeBadgeFromContainer(container) {
    console.log('🏷️ Best Sellers Badge: 开始移除容器中的角标');
    
    // 检查容器是否有效
    if (!container || !container.querySelector) {
      console.log('🏷️ Best Sellers Badge: ❌ 容器无效或不存在，无法移除角标');
      return;
    }
    
    const existingBadge = container.querySelector(`.${this.badgeClass}`);
    if (existingBadge) {
      existingBadge.remove();
      console.log('🏷️ Best Sellers Badge: ✅ 角标移除成功');
    } else {
      console.log('🏷️ Best Sellers Badge: ⚠️ 未找到要移除的角标');
    }
  }
}

// Initialize when script loads
new BestSellersBadge();